import StorageManager from "@/features/storage";
import { getJwtTenantName } from "@/lib/jwt";

/**
 * The tenant the participant is currently authenticated against, decoded from
 * the access token's `tenant_name` claim. Returns null when unauthenticated or
 * the claim is absent, so callers should fall back to a static name.
 */
export const useTenantName = (): string | null => {
  const accessToken = StorageManager.getTokenData()?.access_token;
  return accessToken ? getJwtTenantName(accessToken) : null;
};
